import ReactGA from 'react-ga4';

export interface OutboundClickParams {
  partnerName: string;
  category?: string;
  dealValue?: string;
  linkUrl?: string;
  isFeatured?: boolean;
}

export const trackOutboundClick = ({
  partnerName,
  category = 'General',
  dealValue = '',
  linkUrl = '',
  isFeatured = false
}: OutboundClickParams) => {
  try {
    ReactGA.event('outbound_affiliate_click', {
      partner_name: partnerName,
      category,
      deal_value: dealValue,
      link_url: linkUrl,
      is_featured: isFeatured
    });
  } catch (e) {
    // Fail silently in unsupported test environments
  }
};

export const trackCouponCopy = (partnerName: string, couponCode: string, category: string = 'General') => {
  try {
    ReactGA.event('coupon_code_copied', {
      partner_name: partnerName,
      coupon_code: couponCode,
      category
    });
  } catch (e) {
    // Fail silently
  }
};

export const trackSocialShare = (platform: string, partnerName: string) => {
  try {
    ReactGA.event('social_share_click', {
      platform,
      partner_name: partnerName
    });
  } catch (e) {
    // Fail silently
  }
};

export const trackCategoryFilter = (categoryName: string) => {
  try {
    ReactGA.event('category_filter_selected', {
      category_name: categoryName
    });
  } catch (e) {
    // Fail silently
  }
};

export const trackSearch = (searchTerm: string, resultsCount: number) => {
  try {
    if (searchTerm.trim().length > 1) {
      ReactGA.event('search_performed', {
        search_term: searchTerm.trim(),
        results_count: resultsCount
      });
    }
  } catch (e) {
    // Fail silently
  }
};
